import { useAtomValue } from 'jotai';
import { camelCase } from 'lodash/fp';
import { userNavOverridesAtom } from '@/atoms/queries/user';
import { trackViewConfigurationEvent } from '../analytics';
import { ViewConfiguration, ViewConfigurationSource, ViewType } from '../types';

export const useTrackExperienceChange = (viewType: ViewType, configurationSource: ViewConfigurationSource) => {
  const userNavOverrides = useAtomValue(userNavOverridesAtom);
  const isClassicXp = userNavOverrides[camelCase(viewType) as keyof typeof userNavOverrides];
  const previousConfiguration = isClassicXp ? ViewConfiguration.CLASSIC : ViewConfiguration.NEW;
  const updatedConfiguration = isClassicXp ? ViewConfiguration.NEW : ViewConfiguration.CLASSIC;

  return async () =>
    trackViewConfigurationEvent({
      previousConfiguration,
      updatedConfiguration,
      viewType,
      configurationSource,
    });
};
